const nameValidator = (name: string, required: boolean) => {
  if (!required) return true;
  if (!name) return false;
  return true;
};

export default nameValidator;
